import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const agenda = () => {
  const auth = useAuth();

  async function list(from, to) {
    let retorno;
    try {
      const {data} = await http.get(`/appointments?from=${from}&to=${to}`, auth.getBearer());
      retorno = data;
    } catch (error) {
      console.log(error?.response?.data);
    }
    return retorno;
  }

  async function createItem(agendamento) {
    try {
      await http.post('/appointments', agendamento, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return error?.response?.data?.message ?? false;
    }
  }

  async function updateItem(agendamento) {
    try {
      await http.put('/appointments/'+agendamento.id, agendamento, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      await http.delete('/appointments/'+id, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, createItem, updateItem, deleteItem}
}
